import type { FaireThemeEntity } from "../../entity_types/theme";

export const effortless_layering_essentials: FaireThemeEntity = {
  token: "effortless-layering-essentials",
  type: "theme",
  name: "Effortless Layering Essentials",
  description: "Versatile cardigans and hoodies for transition seasons blending casual comfort and artistic retro style.",
  teaser: "Transition-season layers that match your sweatshirt and knitwear bestsellers.",
  detail: "You frequently order sweatshirts and knitwear for your pop-up. This expands into cardigans and hoodies with the casual, look-younger aesthetic your recently carted items show you're drawn to.",
  bgColor: "#D6E0F0",
  tileBgColor: "#4a5d7a",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_yqpd4fnyac",
    "p_2asezecnvg",
    "p_u4mfrqc8ac",
    "p_4w7a6pw4dz",
    "p_42n546c9et",
    "p_ar6v7butev",
    "p_4352wtknkm",
    "p_jvp997585v",
    "p_ne8wwz8zx9",
    "p_enmra4pcwt",
    "p_6e7w2ra4zc",
    "p_5y4lmdn8wg",
    "p_mme9k3ufaf",
    "p_n6vsmv2pt5",
    "p_reqfvpdyt2",
    "p_df4zvmzr7p",
    "p_mzv7ftuqqm",
    "p_nb2s54h26m",
    "p_mgzz9ym525",
    "p_9uzyn4s6mf",
    "p_9ynfknybd6",
    "p_dxwgdcr6pr",
    "p_zpqnx37cxq",
    "p_fhxz4b6g5k",
    "p_c4z26gu3ds",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
